module.exports = __webpack_public_path__ + "static/goldmansachs-logo-b5d38e14c2bea4d8cb354070d61e3082.png";